import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import Paper from '@mui/material/Paper';
import type { RootState } from '../store';

const mapStateToProps = (_state: RootState) => ({});

function mapDispatchToProps() {
  return {};
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;

class ConnectedTestPage extends Component<Props> {
  override render(): React.JSX.Element {
    return (
      <div style={{ overflowX: 'auto', justifyContent: 'center' }}>
        <Paper>
          <a href="http://app.stash-app.com/ios/log-me-in/a6364a54-5afd-4e80-9105-18faa320837b">
            auth link test
          </a>
        </Paper>
      </div>
    );
  }
}

export default connector(ConnectedTestPage);
